<script>
import useSharedData from "@/use/SharedData.js";
import useValidation from "@/use/Validation.js";
import useTools from "@/use/Tools.js";
import useSharedMethod from "@/use/SharedMethod.js";
import {ref} from "vue";
import StrWorker from "@/components/StrWorker.vue";
import axios from "axios";

export default {
    components: {StrWorker},
    setup() {
        const {mxRules} = useValidation();
        const {$refs} = useTools();
        const {getBack} = useSharedMethod();
        const {loading, dialog} = useSharedData();
        const dataAccess = ref(null);
        const data = ref({
            filter: {},
            workers: [],
        });

        function save() {
            if ($refs.form.validate()) {
                loading.value = true;
                const ids = data.value.workers.map((w) => w.id);
                const body = {
                    ids: ids,
                    dataAccess: dataAccess.value,
                };
                axios.put(`/workers/setDataAccess`, body, {
                    params: data.value.filter,
                }).then(() => {
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        return {
            mxRules,
            loading,
            dialog,
            dataAccess,
            data,
            save,
            getBack
        }
    }
};
</script>

<template>
    <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        persistent
        max-width="1200"
        scrollable
    >
        <v-card>
            <w-toolbar color="teal" :title="$t('worker.set_data_access')"/>
            <v-divider/>
            <v-card-text>
                <StrWorker v-model="data" action="UPDATE_WORKER">
                    <v-container fluid>
                        <v-form ref="form" lazy-validation>
                            <v-row>
                                <v-col cols="12">
                                    <w-label :label="$t('worker.data_access')" required/>
                                    <w-text-field
                                        v-model="dataAccess"
                                        type="number"
                                        min="1"
                                        :rules="[mxRules.required]"
                                    />
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </StrWorker>
            </v-card-text>

            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-add
                    show
                    :loading="loading"
                    @press="save"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>